module.exports = __webpack_public_path__ + "static/img/084_TO8_1734_og.01fc413.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/084_TO8_1734_og.jpg
// module id = TcLn
// module chunks = 0